<template>
  <div>
    <!-- Breadcrumb -->
    <app-breadcrumb>
      <template #contentright>
        <b-button
          v-if="$route.params.id !== undefined"
          variant="outline-primary"
          :to="{ name: 'groups-add' }"
        >
          <span class="text-nowrap">
            <feather-icon icon="PlusCircleIcon" /> {{ $t('Add New') }} </span>
        </b-button>
        <span v-else />
      </template>
    </app-breadcrumb>

    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-tabs>
        <b-tab active>
          <template #title>
            <feather-icon icon="InfoIcon" />
            <span>Thông tin chung</span>
          </template>
          <groups-tab-general
            :group-data="itemData"
            @reset-form="resetData"
            @fetch-data="fetchData"
          />
        </b-tab>
        <b-tab
          lazy
          :disabled="!$route.params.id"
        >
          <template #title>
            <feather-icon icon="GitPullRequestIcon" />
            <span>Cấp luồng</span>
          </template>
          <groups-tab-assign-workflow :group-data="itemData" />
        </b-tab>
        <b-tab
          lazy
          :disabled="!$route.params.id"
        >
          <template #title>
            <feather-icon icon="ShieldIcon" />
            <span>Cấp quyền</span>
          </template>
          <groups-tab-assign-role :group-data="itemData" />
        </b-tab>
        <b-tab
          lazy
          :disabled="!$route.params.id"
        >
          <template #title>
            <feather-icon icon="UsersIcon" />
            <span>Thêm user</span>
          </template>
          <groups-tab-assign-user :group-data="itemData" />
        </b-tab>

      </b-tabs>
    </b-overlay>
  </div>
</template>

<script>
import {
  BCard, BOverlay, BButton, BRow, BCol,
  BTabs, BTab,
} from 'bootstrap-vue'
import {
  ref, watch,
} from '@vue/composition-api'
import store from '@/store'
import { useRouter, showToast } from '@core/utils/utils';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  required, alphaNum, alphaNumDot, max, integer,
} from '@validations';
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'
import GroupsTabGeneral from './GroupsTabGeneral.vue'
import GroupsTabAssignWorkflow from './GroupsTabAssignWorkflow.vue'
import GroupsTabAssignRole from './GroupsTabAssignRole.vue'
import GroupsTabAssignUser from './GroupsTabAssignUser.vue'

export default {
  components: {
    AppBreadcrumb,
    GroupsTabGeneral,
    GroupsTabAssignWorkflow,
    GroupsTabAssignRole,
    GroupsTabAssignUser,
    BOverlay,
    BButton,
    BTabs,
    BTab,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      required,
      integer,
      alphaNum,
      alphaNumDot,
      max,
    }
  },
  computed: {

  },

  setup() {
    const { route } = useRouter();
    const id = ref(route.value.params.id !== undefined ? route.value.params.id : 0);
    const layout = ref(route.value.name !== 'groups-edit' ? 'add' : 'edit');
    const loading = ref(!!id.value)
    const errorMessage = ref('')
    const groups = ref([])
    const userItems = ref([])
    const defaultItemData = {
      name: '',
      description: '',
    }

    const itemData = ref(JSON.parse(JSON.stringify(defaultItemData)))

    const resetData = () => {
      itemData.value = JSON.parse(JSON.stringify(defaultItemData))
    }

    const fetchData = (gid) => {
      loading.value = true;
      store.dispatch('groups/fetchGroup', { id: gid || id.value })
        .then(response => {
          loading.value = false

          if (response.status === 200) {
            itemData.value = response.data.data
            errorMessage.value = '';
          } else {
            errorMessage.value = response.message
          }
        })
    }
    if (id.value && layout.value === 'edit') {
      fetchData();
    }

    return {
      id,
      layout,
      errorMessage,
      loading,
      itemData,
      groups,
      userItems,
      resetData,
      fetchData,
    }
  },

}
</script>

<style></style>
